import {
	getController,
	apiService as Service,
	type HpRequestOptional,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'roles'

export const roleService = {
	...getController<Api.Sync>(url),
	index: (data?: HpRequestOptional) =>
		Service.get<Api.Collection<Api.Sync>>({
			url: `${url}?of=hp_id&od=ASC`,
			...data,
		}),
	update: (id: number, data: HpRequestPostPut<unknown>) =>
		Service.put<unknown>({
			url: `${url}/${id}`,
			...data,
		}),
	attachToModule: (
		id: number,
		target: string,
		targetId: number,
		subTarget: string,
		data: HpRequestOptional<Api.RolesAttachingWithUnlimitedParamInput>
	) =>
		Service.post({
			url: `${url}/${id}/${target}/${targetId}/${subTarget}`,
			...data,
		}),
}

export default roleService
